import { render, staticRenderFns } from "./CommentResponseTemplate.vue?vue&type=template&id=8eb56992&"
import script from "./CommentResponseTemplate.vue?vue&type=script&lang=js&"
export * from "./CommentResponseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CommentResponseTemplate.vue?vue&type=style&index=0&id=8eb56992&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports